import { memo } from 'react';
import cls from 'classnames';

import styles from './CirclesLoader.module.scss';

interface LoaderProps {
  appearance: 'black' | 'white' | 'colored';
  size: 'large' | 'medium' | 'small';
  className: string;
}

const APPEARANCE_CLASS_MAP: Record<LoaderProps['appearance'], string> = {
  black: styles.loaderBlack,
  white: styles.loaderWhite,
  colored: styles.loaderColored,
};

const SIZE_CLASS_MAP: Record<LoaderProps['size'], string> = {
  large: styles.loaderLarge,
  medium: styles.loaderMedium,
  small: styles.loaderSmall,
};

function CirclesLoader(props: Partial<LoaderProps>) {
  const { appearance = 'colored', size = 'medium', className } = props;

  return (
    <div className={cls(styles.loader, APPEARANCE_CLASS_MAP[appearance], SIZE_CLASS_MAP[size], className)}>
      <span />

      <span />

      <span />
    </div>
  );
}

export default memo(CirclesLoader);
